import getMeshFromModel from "../getMeshFromModel";
import { plant, screen } from "./assets/props";

/** @param {{ name: "plant" | "screen"; [x: string]: any }} props */
const Props = ({ name, ...props }) => {
  const meshModel = name === "plant" ? plant : screen;
  const propsMesh = getMeshFromModel(meshModel);
  return <group {...props}>{propsMesh}</group>;
};

export default Props;
